export default __webpack_public_path__ + "static/media/Helm of the Deathstalker.c883e75d.jpg";